import { render, staticRenderFns } from "./ModalHolidaysEvent.vue?vue&type=template&id=b2607082&"
import script from "./ModalHolidaysEvent.vue?vue&type=script&lang=js&"
export * from "./ModalHolidaysEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports